module.exports = __webpack_public_path__ + "static/img/01.e94cd2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour5/01.jpg
// module id = 0NAI
// module chunks = 0